export const rowIndexColumnName = "$rowIndex";
export const nativeTableRowIDColumnName = "$rowID";
export const nativeTableRowDeletedColumnName = "$rowDeleted";
export const isFavoritedColumnName = "$isFavorited";
